export default function(){
    (function($) {
        var menuOpened = false;


        $(".nav__hamburger").on("click", function (ev) {
            menuOpened = !menuOpened;
            if(menuOpened){
                $(".nav__content").addClass("nav__content--active");
                $('body').addClass('o-hidden');
            } else {
                $(".nav__content").removeClass("nav__content--active");
                $('body').removeClass('o-hidden');
            }
            $(".hamburger-icon").toggleClass("hamburger-icon--opened");
        })


        $(".nav__hamburger").on("click", function (ev) {
            $(".nav").toggleClass("nav--opened");
        })

        $(".nav__content").on("transitionend", function () {
            if(!menuOpened){
                $(".nav__container").removeClass("nav--black-bg");
            }
        })

        $(".nav__content").on("transitionend", function () {
            if(!menuOpened){
                $(".nav__container").removeClass("nav--black-bg");
            }
        })

        $(".nav__link").on("click", function () {
            if($(".nav").hasClass("nav--opened")){
                $(".nav").removeClass("nav--opened");
            }
        })

        $(".menu-item-has-children").on("click", function () {
            $(".menu-item-has-children > .sub-menu").toggleClass("sub-menu--opened");
            $(this).toggleClass("menu-item--opened");
        })

        const nav = $(".nav__mobile-header");
        $(window).scroll( function () {
            if(window.pageYOffset > 0){
                nav.addClass("nav__mobile-header--background")
            } else {
                nav.removeClass("nav__mobile-header--background")
            }
        })

        $(window).scroll(function(e) {
            e.preventDefault();
            if ($(window).scrollTop() > 100 || $(window).scrollTop() > 100 && $('body').hasClass('sidebar-cart-opened')) {
                $('.nav').addClass("scrolled");
            } else {
                $('.nav').removeClass("scrolled");
            }
        });

        // Script
        let lastScroll = 0;
        $(window).on('scroll',function() {
            var scroll = $(window).scrollTop();
            if(lastScroll - scroll > 0) {
                $(".nav").addClass("scrollUp");
            } else {
                $(".nav").removeClass("scrollUp");
            }
            lastScroll = scroll;
        });







        // Sidebar cart


        var fromTop;
        function sidebar_cart_open(){
            // Fix content
            fromTop = $(window).scrollTop();
            $(".body-content").css({
                position: "fixed",
                top: -fromTop,
                width: "100%"
            });
            if($('body').hasClass('sidebar-cart-opened')){
                sidebar_cart_close();
            }
            if (fromTop > 100) {
                $(".navigation").addClass("scrolled");
            }
            // Add body class
            $('body').addClass('sidebar-cart-opened');

        }

        function sidebar_cart_close(){
            $('body').removeClass('sidebar-cart-opened');

            $(".body-content").removeAttr("style");
            $(window).scrollTop(fromTop);
            $(".navigation.scrolled.scrollUp").css ({
                top: "0",
            });
            if ($(window).scrollTop() > 100 ) {
                $('.navigation').addClass("scrolled");
            }
        }


        function sidebar_cart_init(){

            $('.body-content, .sidebar-cart__close').click(function(e){
                if($('body').hasClass('sidebar-cart-opened')){
                    sidebar_cart_close();
                }
            });


        }


        $('body').on('click','.header__icon_cart, .open-cart', function(e){
            e.preventDefault();

            setTimeout( sidebar_cart_open , 1 );

        });

        $(function() {
            sidebar_cart_init();
        });

        $( document.body ).on( 'wc_fragments_refreshed', () => {
            sidebar_cart_init();
        } );


        $( document ).on( "creepy-add-to-cart-success", function() {
            sidebar_cart_init();
            sidebar_cart_open();
        });

        $( document ).on( "creepy-add-to-cart-error", function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            $("button.single_add_to_cart_button").attr("disabled", true)

            setTimeout(() => {
                $("button.single_add_to_cart_button").attr("disabled", false)
            }, 5000)

        });







    })(jQuery);
}